var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationAlt = function SvgLocationAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.132 3.868c-4.491-4.49-11.773-4.49-16.264 0-4.49 4.491-4.49 11.773 0 16.264 4.491 4.49 11.773 4.49 16.264 0 4.484-4.494 4.484-11.77 0-16.264Zm-7.404 14.995a.5.5 0 0 1-.48-.302l-2.043-4.766-4.766-2.042a.5.5 0 0 1 .039-.935l10.606-3.535a.521.521 0 0 1 .633.633l-3.535 10.606a.5.5 0 0 1-.454.341Z"
  })));
};
export default SvgLocationAlt;